import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { composeEventHandlers } from '@radix-ui/primitive';
import { Primitive } from '@radix-ui/react-primitive';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef, useState, useImperativeHandle } from 'react';
import { animationTimingFunctionVar, animationDurationVar, animationNameVar, root } from './animationController.vanilla.mjs';

const AnimationController = forwardRef(
  ({
    initialAnimation = false,
    duration = 0.3,
    easing = "ease-in-out",
    animation,
    onAnimationEnd,
    children,
    className,
    style,
    ...restProps
  }, ref) => {
    const [animationFlag, setAnimationFlag] = useState(initialAnimation);
    const setAnimationTrue = () => {
      setAnimationFlag(true);
    };
    const setAnimationFalse = () => {
      setAnimationFlag(false);
    };
    useImperativeHandle(
      ref,
      () => ({
        triggerAnimation: setAnimationTrue
      }),
      [setAnimationTrue]
    );
    return /* @__PURE__ */ jsx(
      Root,
      {
        ...restProps,
        onAnimationEnd: composeEventHandlers(onAnimationEnd, setAnimationFalse),
        className: animationFlag ? classNames(className, root) : className,
        style: {
          ...assignInlineVars({
            [animationNameVar]: animation,
            [animationDurationVar]: `${duration}s`,
            [animationTimingFunctionVar]: easing
          }),
          ...style
        },
        children
      }
    );
  }
);
const Root = styled(Primitive.div);

export { AnimationController as default };
//# sourceMappingURL=AnimationController.mjs.map
